<template>
  <div>
    <div class="box f-c-c">
      <img src="https://img.kakaclo.com/web-img/404.png" />
      <div style="">{{ $t('Index.page404.Tips1') }}</div>
      <el-button @click="jumpHref('/mall')">{{ $t('Index.page404.GoBack') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    jumpHref(path) {
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  flex-direction: column;
  padding: 80px 0;
  >img {
    width: 200px;
    height: 200px;
  }
  >div {
    margin: 24px 0;
  }
  /deep/ .el-button {
    padding: 10px 60px;
  }
}
</style>
